const ACTIONS = {
  FETCH_LOG_LIST_INIT: "FETCH_LOG_LIST_INIT",
  FETCH_LOG_LIST_SUCCESS: "FETCH_LOG_LIST_SUCCESS",
  FETCH_LOG_LIST_FAILURE: "FETCH_LOG_LIST_FAILURE",
};

export default ACTIONS;
